
// import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from '@mui/material';
// import { Box } from '@mui/system';
// import React, { useEffect, useState } from 'react';
// import { Grid } from 'rsuite';
// import PageContainer from 'src/components/container/PageContainer';
// import TextInputs from 'src/components/inputs/TextInputs';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import ClinetSuggestion from '../ClinetSuggestion';
// import { Button } from 'reactstrap';
// import RadioInputs from 'src/components/inputs/RadioInputs';
// import { useMain } from 'src/views/hooks/useMain';
// import { useNavigate, useParams } from 'react-router';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { ExpandLess, ExpandMore } from '@mui/icons-material';
// import { maskData } from 'src/views/Billings/AddBill';

// const PackageDetails = () => {
//   const [data, setData] = useState({});
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({ clientNumber: '', packageId: '', paymentType: '', gender: '', clientName: '' });
//   const [clientSuggested, setClientSuggested] = useState([]);
//   const [clientExists, setClientExists] = useState(true);
//   const [allClinetsData, setAllClinetsData] = useState([]);
//   const [showNewClientFields, setShowNewClientFields] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [dropDownIcon, setDropdownIcon] = useState(false);
//   const [createdBill, setCreatedBill] = useState({});
//   const [openBillDialogue, setOpenBillDialogue] = useState(false);

//   const { packageId } = useParams();
//   const navigate = useNavigate();
//   const { fetchSinglePackageDetail, buyPackage, activeBranchId, setShowMessage, getBranch, branchData } = useMain();

//   const getSinglePackageData = async (packageId, activeBranchId) => {
//     try {
//       setLoading(true);
//       const res = await fetchSinglePackageDetail(packageId, activeBranchId);
//       if (res.statusCode === 200) {
//         setData(res.data);
//       } else {
//         setShowMessage({ message: res.message || "Error Occurred while fetching package details", messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || "Something went wrong", messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };
//   console.log(data, "packageBuyDataa")

//   useEffect(() => {
//     if (activeBranchId && packageId) {
//       getSinglePackageData(packageId, activeBranchId);
//     }
//     return () => {
//       setData({});
//     };
//   }, [activeBranchId, packageId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (name === 'clientNumber') {
//       updateSuggested(value);
//     }
//   };

//   const handleBuyPackage = async () => {
//     const { clientNumber, paymentType, clientName } = formData;
//     if (clientNumber === '' || clientNumber.length !== 10)
//       return setShowMessage({ message: 'Client Number is required or invalid', messageType: 'error' });
//     if (paymentType === '')
//       return setShowMessage({ message: 'Payment Type is required', messageType: 'error' });

//     let requestBody = { clientNumber, packageId, paymentType, clientName };
//     if (!clientExists) {
//       requestBody = { ...formData };
//     }

//     try {
//       setLoading(true);
//       const res = await buyPackage(activeBranchId, requestBody);
//       if (res.statusCode === 200) {
//         setShowMessage({ message: res.message || "Successfully Bought Package", messageType: 'success' });
//         setCreatedBill(res?.data)
//         setOpenBillDialogue(true);
//         handleCloseDialogue();
//       } else {
//         setShowMessage({ message: res.message || "Error Occurred while Buying Package", messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || "Something went wrong", messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateSuggested = (inputValue) => {
//     const suggestions = allClinetsData.filter((client) =>
//       client.clientNumber.toLowerCase().includes(inputValue.toLowerCase()),
//     );
//     setClientSuggested(suggestions);
//     setClientExists(suggestions.length > 0);
//   };

//   const handleSuggestedClick = (client) => {
//     setFormData(prev => ({ ...prev, clientNumber: client.clientNumber }));
//     setClientSuggested([]);
//   };

//   const handleOpenDialogue = () => {
//     setOpenDialogue(true);
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//     setFormData({ clientNumber: '', packageId: data._id, paymentType: '', gender: '', clientName: '' });
//     setClientSuggested([]);
//     setShowNewClientFields(false);
//   };

//   const getBranchData = async (activeBranchId) => {
//     try {
//       const res = await getBranch(activeBranchId);
//       if (res.statusCode === 200) {
//         setAllClinetsData(res?.data?.client || []);
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || "Something went wrong", messageType: 'error' });
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getBranchData(activeBranchId);
//     }
//     return () => {
//       setAllClinetsData([]);
//     };
//   }, [activeBranchId]);

//   const handleAddNew = () => {
//     setFormData(prev => ({ ...prev, packageId: data._id, clientName: '', gender: '' }));
//     setShowNewClientFields(true);
//   };

//   const handleAmountPaidInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const toggleDropdown = () => {
//     setDropdownOpen(prev => !prev);
//   };

//   const toggleDropdownIcon = () => {
//     setDropdownIcon(prev => !prev);
//   };

//   const handleBillCloseDialogue = () => {
//     setCreatedBill({});
//     setOpenBillDialogue(false);
//   };

//   return (
//     <PageContainer title="Package Details" description="This is Package type membership details">
//       <DashboardCard title="Package Details">
//         <Grid container spacing={4}>
//           <Grid container item xs={12} md={8} spacing={2} style={{ padding: '1rem' }}>
//             <Grid container item xs={12} alignItems="center" style={{ display: 'flex', alignItems: 'center', gap: '30px', padding: '1rem' }}>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Package Name: <strong>{data.packageName}</strong>
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Package Price: <strong>{data.price}</strong>
//                 </Typography>
//               </Grid>
//             </Grid>

//             <Grid container item xs={12} alignItems="center" style={{ display: 'flex', alignItems: 'center', gap: '3.5rem', padding: '1rem' }}>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Package services: <strong>Services</strong>
//                   <IconButton onClick={toggleDropdownIcon}>
//                     {dropDownIcon ? <ExpandLess /> : <ExpandMore />}
//                   </IconButton>
//                   {dropDownIcon && (
//                     <ul
//                       style={{
//                         listStyle: 'none',
//                         padding: '8px',
//                         margin: 0,
//                         maxHeight: '200px',
//                         overflowY: 'auto',
//                         border: '1px solid #ddd',
//                         borderRadius: '10px',
//                         backgroundColor: '#FAFAFA'
//                       }}
//                     >
//                       {data.services?.map(service => (
//                         <li key={service._id}>
//                           <strong>{service.serviceName}</strong>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Valid Till: <strong>{data.packageDuration ? data.packageDuration : data?.validTill}</strong>
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <button
//               style={{
//                 float: 'right',
//                 backgroundColor: '#6174DD',
//                 padding: '10px 15px',
//                 color: '#fff',
//                 borderRadius: '5px',
//                 fontSize: '14px',
//                 border: 'none',
//                 marginBottom: '10px',
//               }}
//               onClick={handleOpenDialogue}
//             >
//               Buy Package
//             </button>
//           </Grid>

//           <Grid item xs={12}>
//             <table className="table-container mt-3">
//               <thead className="table-thead">
//                 <tr>
//                   {['Package Name', 'Package Services', 'Package Price'].map((h, index) => (
//                     <th key={index} style={{ width: '100%' }}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="table-tbody">
//                 <tr>
//                   <td style={{ width: '100%' }}>{data?.packageName}</td>
//                   <td style={{ width: '100%' }}>
//                     <div style={{ position: 'relative' }}>
//                       <button
//                         onClick={toggleDropdown}
//                         style={{
//                           cursor: 'pointer',
//                           padding: '5px',
//                           fontWeight: 'bold',
//                           backgroundColor: '#6D8196',
//                           color: 'white',
//                           border: 'none',
//                           borderRadius: '5px'
//                         }}>
//                         {dropdownOpen ? 'Hide Services' : 'Show Services'}
//                       </button>
//                       {dropdownOpen && (
//                         <div
//                           style={{
//                             position: 'absolute',
//                             backgroundColor: '#fff',
//                             border: '1px solid #ddd',
//                             borderRadius: '4px',
//                             padding: '10px',
//                             marginTop: '5px',
//                             zIndex: 1000,
//                             width: 'max-content',
//                             overflow: 'hidden',
//                             maxHeight: '100px', // Set a maximum height for the dropdown
//                             overflowY: 'auto' // Add vertical scroll
//                           }}
//                         >
//                           <ul style={{ listStyleType: 'none', padding: 0 }}>
//                             {data?.services?.map(item => (
//                               <li key={item._id}>
//                                 <strong>{item?.serviceName}</strong><br />
//                               </li>
//                             ))}
//                           </ul>
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                   <td style={{ width: '100%' }}>{data?.price}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </Grid>
//         </Grid>
//         <Dialog
//           open={openDialogue}
//           onClose={handleCloseDialogue}
//           maxWidth="md"
//           sx={{
//             '& .MuiDialog-paper': {
//               width: '600px',
//               minHeight: '50vh',
//             },
//           }}
//         >
//           <DialogTitle> Buy Package</DialogTitle>
//           <DialogContent>
//             <DialogContentText>Here you can buy Package.</DialogContentText>
//             <Grid container spacing={2}>
//               <Grid item xs={8}>
//                 <Box style={{ borderBottom: 'none', width: '22.5rem' }}>
//                   <TextInputs
//                     title={'Client Number'}
//                     name={'clientNumber'}
//                     placeholder='Enter client number'
//                     value={formData?.clientNumber}
//                     handleChange={handleChange}
//                     type={'text'}
//                   />
//                 </Box>
//               </Grid>
//               {!clientExists && !showNewClientFields && (
//                 <Grid item xs={4} style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
//                   <Button
//                     variant="contained"
//                     onClick={handleAddNew}
//                     style={{ backgroundColor: '#6174DD', borderColor: '#6174DD' }}
//                   >
//                     Add New
//                   </Button>
//                 </Grid>
//               )}
//               <Grid item xs={12}>
//                 {clientExists && formData.clientNumber && ( // Only show suggestions if client exists and input is not empty
//                   <ClinetSuggestion
//                     data={clientSuggested}
//                     handleSuggestedClick={handleSuggestedClick}
//                   />
//                 )}
//                 {showNewClientFields && !clientExists && (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                     <Box style={{ borderBottom: 'none', width: '22.5rem' }}>
//                       <TextInputs
//                         title={'Client Name'}
//                         name={'clientName'}
//                         value={formData?.clientName}
//                         handleChange={handleChange}
//                         type={'text'}
//                       />
//                     </Box>
//                     <Box style={{ borderBottom: 'none', width: '22.5rem' }}>
//                       <RadioInputs
//                         title={'Gender'}
//                         name={'gender'}
//                         value={formData?.gender}
//                         handleChange={handleChange}
//                         options={[
//                           { title: 'Male', value: 'Male' },
//                           { title: 'Female', value: 'Female' },
//                         ]}
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </Grid>
//             </Grid>

//             <Grid container spacing={3}>
//               <Grid item xs={6}>
//                 <Box style={{ borderBottom: 'none', width: '22.5rem' }}>
//                   <Typography component="label"><strong>Payment Type</strong></Typography>
//                   <select
//                     className="form-select"
//                     aria-label="Default select example"
//                     data-validation="required"
//                     name="paymentType"
//                     value={formData.paymentType || ''}
//                     onChange={handleAmountPaidInputChange}
//                     style={{
//                       display: 'block',
//                       width: '100%',
//                       padding: '13px',
//                       fontSize: '16px',
//                       margin: '8px 0',
//                       borderRadius: '4px',
//                     }}
//                   >
//                     <option value="">
//                       --Select--
//                     </option>
//                     <option value="Cash">Cash</option>
//                     <option value="Credit/Debit Card">Credit/Debit card</option>
//                     <option value="Paytm">Paytm</option>
//                     <option value="PhonePe">PhonePe</option>
//                     <option value="Gpay">Gpay</option>
//                   </select>
//                 </Box>
//               </Grid>
//               <Grid item xs={6} style={{ borderBottom: 'none', width: '22.5rem' }}>
//                 <TextInputs
//                   title={'Amount Paid'}
//                   name={'amountPaid'}
//                   placeholder='amount paid'
//                   value={formData.amountPaid || data?.price}
//                   handleChange={handleAmountPaidInputChange}
//                   type={'text'}
//                 />
//               </Grid>
//             </Grid>
//           </DialogContent>

//           <DialogActions>
//             <Button style={{ backgroundColor: '#FF474D', color: 'white' }} onClick={handleCloseDialogue}>Cancel</Button>
//             <Button style={{ backgroundColor: '#6174DD', color: 'white' }} onClick={handleBuyPackage} disabled={loading}>
//               {loading ? 'Buying...' : 'Buy Package'}
//             </Button>
//           </DialogActions>
//         </Dialog>
//         <Dialog
//           open={openBillDialogue}
//           onClose={handleBillCloseDialogue}
//           PaperProps={{
//             style: {
//               maxWidth: '1200px',
//               width: '50%',
//               minHeight: '40%',
//             },
//           }}
//         >
//           <DialogTitle>Bill Details</DialogTitle>
//           <DialogContent>
//             <DialogContentText>Here you can see Bill details.</DialogContentText>
//             <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//               <table className="table-container mt-3">
//                 <thead className="table-thead">
//                   <tr>
//                     {['Date of Bill', 'Client Name', 'Contact', 'Total', 'Paid', 'Pending'].map(
//                       (h, index) => {
//                         return (
//                           <th key={index} style={{ width: '100%' }}>
//                             {h}
//                           </th>
//                         );
//                       },
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody className="table-tbody">
//                   <tr key={createdBill._id}>
//                     <td style={{ width: '100%' }}>{createdBill?.dateOfBilling}</td>
//                     <td style={{ width: '100%' }}>{createdBill?.clientName}</td>
//                     <td style={{ width: '100%' }}>
//                       {typeof branchData?.isMasked !== 'boolean' || !createdBill?.clientNumber
//                         ? 'loading...'
//                         : maskData(createdBill?.clientNumber, branchData?.isMasked)}
//                     </td>
//                     <td style={{ width: '100%' }}>{createdBill?.amountPayable}</td>
//                     <td style={{ width: '100%' }}>
//                       {createdBill?.amountPaid?.reduce(
//                         (acc, payment) => acc + Number(payment.amount),
//                         0,
//                       )}
//                     </td>
//                     <td style={{ width: '100%' }}>0</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ gap: '20px' }}>
//             <Button
//               variant="contained"
//               // fullWidth
//               color="primary"
//               target="_blank"
//               sx={{
//                 background: '#6174DD',
//               }}
//               onClick={handleBillCloseDialogue}
//             >
//               Not Now
//             </Button>

//             <Button
//               variant="contained"
//               // fullWidth
//               color="primary"
//               target="_blank"
//               sx={{
//                 background: '#6174DD',
//               }}
//               onClick={() => navigate(`/Packagebilling/${createdBill?._id}`)}
//             >
//               View Bill
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {loading && <ShowLoader />}
//       </DashboardCard>
//     </PageContainer >

//   );
// }

// export default PackageDetails

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Button,
  CircularProgress,
  Box,
  Divider,
  IconButton,
  DialogContentText
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import TextInputs from 'src/components/inputs/TextInputs';
import DashboardCard from 'src/components/shared/DashboardCard';
import { useMain } from 'src/views/hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import ClinetSuggestion from '../ClinetSuggestion';
import RadioInputs from 'src/components/inputs/RadioInputs';
import { useNavigate, useParams, useLocation } from 'react-router';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { maskData } from 'src/views/Billings/AddBill';
import { changeDateFormate } from 'src/utils/dateutils';

const PackageDetails = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openBillDialogue, setOpenBillDialogue] = useState(false);
  const [createdBill, setCreatedBill] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropDownIcon, setDropdownIcon] = useState(false);
  const [allClinetsData, setAllClinetsData] = useState([]);

  const { packageId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { 
    fetchSinglePackageDetail, 
    buyPackage, 
    activeBranchId, 
    setShowMessage, 
    getBranch, 
    branchData 
  } = useMain();

  // Initial form state
  const initialFormState = {
    clientNumber: '',
    packageId: packageId,
    paymentType: '',
    clientName: '',
    gender: '',
    paidAmount: data?.price,
    paidDues: 0
  };

  const [formData, setFormData] = useState(initialFormState);
  const [clientSuggested, setClientSuggested] = useState([]);
  const [clientExists, setClientExists] = useState(true);
  const [showNewClientFields, setShowNewClientFields] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const TrimData = (data) => {
    if (data?.length < 20) return data;
    return data?.substring(0, 10) + data?.substring(data?.length - 10) + '...';
  };
  // Fetch package details
  const getSinglePackageData = async (packageId, activeBranchId) => {
    try {
      setLoading(true);
      const res = await fetchSinglePackageDetail(packageId, activeBranchId);
      if (res.statusCode === 200) {
        setData(res.data);
        // Initialize form with package price
        setFormData(prev => ({
          ...prev,
          paidAmount: res.data.price,
          paidDues: 0
        }));
      } else {
        setShowMessage({ 
          message: res.message || "Error fetching package details", 
          messageType: 'error' 
        });
      }
    } catch (error) {
      setShowMessage({ 
        message: error.message || "Something went wrong", 
        messageType: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch branch data for client list
  const getBranchData = async (activeBranchId) => {
    try {
      const res = await getBranch(activeBranchId);
      if (res.statusCode === 200) {
        setAllClinetsData(res?.data?.client || []);
      }
    } catch (error) {
      setShowMessage({ 
        message: error.message || "Something went wrong", 
        messageType: 'error' 
      });
    }
  };

  // Set client number from location state if available
  useEffect(() => {
    if (location.state?.clientNumber) {
      updateFormField('clientNumber', location.state.clientNumber);
    }
  }, [location.state]);

  // Initial data fetch
  useEffect(() => {
    if (activeBranchId && packageId) {
      getSinglePackageData(packageId, activeBranchId);
      getBranchData(activeBranchId);
    }
    return () => {
      setData({});
      setAllClinetsData([]);
    };
  }, [activeBranchId, packageId]);

const updateFormField = (name, value) => {
  setFormData(prev => {
    const updatedForm = { ...prev };

    if (name === 'paidAmount' && data.price) {
      let paid = Number(value) || 0;

      // Cap the amountPaid to data.price
      if (paid > data.price) {
        paid = data.price;
      }

      updatedForm.paidAmount = paid;
      updatedForm.paidDues = Math.max(0, data.price - paid);
    } else {
      updatedForm[name] = value;
    }

    return updatedForm;
  });

  // Update client suggestions when client number changes
  if (name === 'clientNumber') {
    updateClientSuggestions(value);
  }
};


  // Update client suggestions based on input
  const updateClientSuggestions = (inputValue) => {
    const suggestions = allClinetsData.filter(client =>
      client.clientNumber?.toLowerCase().includes(inputValue.toLowerCase())
    );
    setClientSuggested(suggestions);
    setClientExists(suggestions.length > 0);
  };

  // Handle client selection from suggestions
  const handleSuggestedClick = (client) => {
    updateFormField('clientNumber', client.clientNumber);
    setClientSuggested([]);
  };

  // Dialog control functions
  const handleOpenDialogue = () => setOpenDialogue(true);
  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    setShowNewClientFields(false);
    setClientExists(true);
    setFormData({
      ...initialFormState,
      paidAmount: data.price || 0,
      paidDues: 0
    });
  };

  // Handle adding new client
  const handleAddNew = () => {
    setShowNewClientFields(true);
    setClientExists(false);
    updateFormField('clientName', '');
    updateFormField('gender', '');
  };

  // Handle package purchase
  const handleBuyPackage = async () => {
    const { clientNumber, paymentType, paidAmount } = formData;
    
    // Validation
    if (!clientNumber || clientNumber.length !== 10) {
      return setShowMessage({
        message: 'Valid 10-digit client number is required',
        messageType: 'error',
      });
    }
    
    if (!paymentType) {
      return setShowMessage({
        message: 'Payment type is required',
        messageType: 'error',
      });
    }

    // if (!paidAmount || isNaN(paidAmount)) {
    //   return setShowMessage({
    //     message: 'Valid amount is required',
    //     messageType: 'error',
    //   });
    // }

    const requestBody = {
      ...formData,
      packageId: data._id
    };

    try {
      setLoading(true);
      const {amountPaid, ...rest} = requestBody
      console.log(rest,'rest')
      const res = await buyPackage(activeBranchId, rest);
      
      const message = res.statusCode === 200 
        ? res.message || "Package purchased successfully"
        : res.message || "Error purchasing package";
        
      setShowMessage({ 
        message, 
        messageType: res.statusCode === 200 ? 'success' : 'error' 
      });

      if (res.statusCode === 200) {
        setCreatedBill(res?.data);
        setOpenBillDialogue(true);
        handleCloseDialogue();
      }
    } catch (error) {
      setShowMessage({ 
        message: error.message || "Something went wrong", 
        messageType: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBillCloseDialogue = () => {
    setCreatedBill({});
    setOpenBillDialogue(false);
  };

  // Package info display
  const renderPackageInfo = () => (
    <Box sx={{ 
      p: 2, 
      mt: 2, 
      border: '1px solid #e0e0e0', 
      borderRadius: 1,
      bgcolor: '#fafafa'
    }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            Package: <strong>{data.packageName}</strong>
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Duration: <strong>{data.packageDuration || data?.validTill}</strong>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            Total Price: <strong>₹{data.price}</strong>
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Dues: <strong>₹{formData.paidDues}</strong>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  // Payment details section
  const renderPaymentSection = () => (
    <>
      <Divider sx={{ my: 1 }} />
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Payment Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: 'black' }}>
              Payment Type *
            </Typography>
            <select
              className="form-select"
              name="paymentType"
              value={formData.paymentType || ''}
              onChange={(e) => updateFormField('paymentType', e.target.value)}
              style={{
                width: '100%',
                padding: '14px',
                marginTop: '0.8rem',
                fontSize: '14px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
              }}
            >
              <option value="">-- Select Payment Method --</option>
              <option value="Cash">Cash</option>
              <option value="Credit/Debit Card">Credit/Debit Card</option>
              <option value="Paytm">Paytm</option>
              <option value="PhonePe">PhonePe</option>
              <option value="Gpay">Google Pay</option>
            </select>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextInputs
            title="Amount Paid"
            name="paidAmount"
            placeholder="Enter amount paid"
            value={formData.paidAmount}
            handleChange={(e) => updateFormField('paidAmount', e.target.value)}
            type="number"
            fullWidth
            inputProps={{
              min: 0,
              max: data.price
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{
            p: 2,
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            bgcolor: '#f5f5f5',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <Typography variant="subtitle1">
              Amount Due:
            </Typography>
            <Typography variant="subtitle1" fontWeight="bold">
              ₹{formData.paidDues}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
  console.log(data,"Dataaaaaaaaaaa")

  return (
    <PageContainer title="Package Details" description="This is Package type membership details">
      <DashboardCard title="Package Details">
        <Grid container spacing={2}>
          {/* Package Info Section */}
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Package Name: <strong>{data.packageName}</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Package price: <strong>₹{data.price}</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {/* <Typography variant="body1">
                  Duration: <strong>{data.packageDuration || data?.validTill}</strong>
                </Typography> */}
                       <Typography variant="body1">
                      {data?.validTill ? "Validity" : "Duration"}: <strong>{data?.validTill ? `${changeDateFormate(data.validTill)}` : `${data?.packageDuration} Months`}</strong>
                </Typography>
              </Grid>
              {/* <Grid item xs={6}>
                <Typography variant="body1">
                  Services: 
                  <IconButton onClick={() => setDropdownIcon(!dropDownIcon)} size="small">
                    {dropDownIcon ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Typography>
                {dropDownIcon && (
                  <ul style={{
                    listStyle: 'none',
                    padding: '8px',
                    margin: 0,
                    maxHeight: '200px',
                    overflowY: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '10px',
                    backgroundColor: '#FAFAFA'
                  }}>
                    {data.services?.map(service => (
                      <li key={service._id}>
                        <strong>{service.serviceName}</strong>
                      </li>
                    ))}
                  </ul>
                )}
              </Grid> */}
            </Grid>
          </Grid>

          {/* <Grid item xs={4} sx={{ textAlign: 'right' }}>
            <Button
              variant="contained"
              onClick={handleOpenDialogue}
              sx={{
                backgroundColor: '#6174DD',
                '&:hover': { backgroundColor: '#4a5abb' }
              }}
            >
              Buy Package
            </Button>
          </Grid> */}

          {/* Services Table */}
          <Grid item xs={12}>
            <table className="table-container mt-3">
              <thead className="table-thead">
                <tr>
                  {['Package Services', 'Category', 'Price'].map((h, index) => (
                    <th key={index} style={{ width: '33%' }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="table-tbody">
                {data?.services?.map((service, index) => (
                  <tr key={service._id}>
                    {/* Service Name with Hover Tooltip */}
                    <td style={{ width: '33%', position: 'relative' }}>
                      <div
                        onMouseEnter={() => setHoveredItemId(service._id + '_serviceName')}
                        onMouseLeave={() => setHoveredItemId(null)}
                        style={{ cursor: 'pointer' }}
                      >
                        {TrimData(service?.serviceName)}

                        {hoveredItemId === service._id + '_serviceName' && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              backgroundColor: '#dfe3f8',
                              border: '1px solid #ccc',
                              padding: '8px',
                              borderRadius: '5px',
                              zIndex: 5,
                              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                              whiteSpace: 'pre-wrap',
                              maxWidth: '300px',
                            }}
                          >
                            {service?.serviceName}
                          </div>
                        )}
                      </div>
                    </td>

                    {/* Other columns */}
                    <td style={{ width: '33%', position: 'relative' }}>{service?.category}</td>
                    <td style={{ width: '33%', position: 'relative' }}>{service?.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Grid>
        </Grid>

        {/* Purchase Dialog */}
        <Dialog
          open={openDialogue}
          onClose={handleCloseDialogue}
          maxWidth="sm"
          fullWidth
          sx={{
            '& .MuiDialog-paper': {
              width: '500px',
              minHeight: '76vh',
            },
          }}
        >
          <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 600, bgcolor: '#f5f5f5' }}>
            Buy Package
          </DialogTitle>

          <DialogContent sx={{ py: 3 }}>
            <Typography variant="body1" color="text.secondary">
              Complete the following details to purchase package
            </Typography>

            {renderPackageInfo()}

            <Grid container spacing={3}>
              {/* Client Number Section */}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <TextInputs
                      title="Client Number"
                      name="clientNumber"
                      placeholder="Enter client number"
                      value={formData.clientNumber}
                      handleChange={(e) => updateFormField('clientNumber', e.target.value)}
                      type="text"
                      fullWidth
                    />
                  </Box>

                  {!clientExists && !showNewClientFields && (
                    <Button
                      variant="contained"
                      onClick={handleAddNew}
                      sx={{
                        backgroundColor: '#6174DD',
                        height: '46px',
                        mb: '8px',
                      }}
                    >
                      Add New
                    </Button>
                  )}
                </Box>

                {clientExists && formData.clientNumber && (
                  <ClinetSuggestion
                    data={clientSuggested}
                    handleSuggestedClick={handleSuggestedClick}
                  />
                )}
              </Grid>

              {/* New Client Fields */}
              {showNewClientFields && !clientExists && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      p: 2,
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      bgcolor: '#fafafa',
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                      New Client Details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextInputs
                          title="Client Name"
                          name="clientName"
                          placeholder="Enter client name"
                          value={formData.clientName}
                          handleChange={(e) => updateFormField('clientName', e.target.value)}
                          type="text"
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <RadioInputs
                          title="Gender"
                          name="gender"
                          value={formData.gender}
                          handleChange={(e) => updateFormField('gender', e.target.value)}
                          options={[
                            { title: 'Male', value: 'Male' },
                            { title: 'Female', value: 'Female' },
                          ]}
                          row
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}

              {/* Payment Section */}
              <Grid item xs={12}>
                {renderPaymentSection()}
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0' }}>
            <Button
              variant="outlined"
              onClick={handleCloseDialogue}
              sx={{
                color: '#f44336',
                borderColor: '#f44336',
                '&:hover': {
                  borderColor: '#d32f2f',
                  backgroundColor: 'rgba(244, 67, 54, 0.04)',
                },
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleBuyPackage}
              disabled={loading}
              sx={{
                backgroundColor: '#6174DD',
                '&:hover': { backgroundColor: '#4a5abb' },
              }}
            >
              {loading ? (
                <>
                  <CircularProgress size={20} sx={{ color: 'white', mr: 1 }} />
                  Processing...
                </>
              ) : (
                'Confirm Purchase'
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Bill Dialog */}
        <Dialog
          open={openBillDialogue}
          onClose={handleBillCloseDialogue}
          PaperProps={{
            style: {
              maxWidth: '1200px',
              width: '50%',
              minHeight: '40%',
            },
          }}
        >
          <DialogTitle>Bill Details</DialogTitle>
          <DialogContent>
            <DialogContentText>Here you can see Bill details.</DialogContentText>
            <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
              <table className="table-container mt-3">
                <thead className="table-thead">
                  <tr>
                    {['Date of Bill', 'Client Name', 'Contact', 'Total', 'Paid', 'Pending'].map(
                      (h, index) => {
                        return (
                          <th key={index} style={{ width: '100%' }}>
                            {h}
                          </th>
                        );
                      },
                    )}
                  </tr>
                </thead>
                <tbody className="table-tbody">
                  <tr key={createdBill._id}>
                    <td style={{ width: '100%' }}>{createdBill?.dateOfBilling}</td>
                    <td style={{ width: '100%' }}>{createdBill?.clientName}</td>
                    <td style={{ width: '100%' }}>
                      {typeof branchData?.isMasked !== 'boolean' || !createdBill?.clientNumber
                        ? 'loading...'
                        : maskData(createdBill?.clientNumber, branchData?.isMasked)}
                    </td>
                    <td style={{ width: '100%' }}>{createdBill?.amountPayable}</td>
                    <td style={{ width: '100%' }}>
                      {createdBill?.amountPaid?.reduce(
                        (acc, payment) => acc + Number(payment.amount),
                        0,
                      )}
                    </td>
                    <td style={{ width: '100%' }}>0</td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </DialogContent>
          <DialogActions sx={{ gap: '20px' }}>
            <Button
              variant="contained"
              color="primary"
              target="_blank"
              sx={{
                background: '#6174DD',
              }}
              onClick={handleBillCloseDialogue}
            >
              Not Now
            </Button>

            <Button
              variant="contained"
              color="primary"
              target="_blank"
              sx={{
                background: '#6174DD',
              }}
              onClick={() => navigate(`/Packagebilling/${createdBill?._id}`)}
            >
              View Bill
            </Button>
          </DialogActions>
        </Dialog>

        {loading && <ShowLoader />}
      </DashboardCard>
    </PageContainer>
  );
};

export default PackageDetails;